<template>
	<v-card class="mt-4">
		<v-card-title>
		<v-icon color="black"> mdi-clock-fast </v-icon> Quick Actions
		</v-card-title>
		<v-card-text>
			<div style="display:grid">
				<v-btn text color="primary"
				v-for="item in routes"
				:key="item.name"
				:to="{name:item.name}">
					{{item.displayName}}
					<v-icon> mdi-arrow-right </v-icon>
				</v-btn>
				<v-btn text color="primary"
				@click="ChangeAccount"
				>
				Switch Account
				<v-icon>
					mdi-arrow-right
				</v-icon>
				</v-btn>
				
				<v-btn text color="error" @click.stop="warnDelete">
					<v-icon>
						mdi-delete
					</v-icon>
					Delete Account
				</v-btn>
			</div> 
		</v-card-text>
		<accidental-guard v-model="dialog" @confirm="removeAccount" />
	</v-card>
</template>

<script>
import {mapActions} from 'vuex'
import Axios from '../services/Axios'
import AccidentalGuard from './AccidentalGuard.vue'
	export default{
  components: { AccidentalGuard },
		name:'QuickNavigation',
		data(){
			return{
				dialog:false,
				routes:[
				{
					name:"All",
					displayName:'AllTransactions',

				},
				{
					name:"Report",
					displayName:'Reports'

				},
				]
			}
		},
		methods:{
			// handle(val){
			// 	this.dialog= val
			// 	console.log(val)
			// },
			...mapActions({
				logout:'auth/logout',
			}),
			ChangeAccount(){
				this.logout()
				this.$router.push({name:'Login'})
			},
			warnDelete(){
				this.dialog=true
				console.log(this.dialog)
			},
			async removeAccount(){
				try{
					await Axios.delete('/me')
					this.logout()
					this.$router.push({name:'Login'})
				}
				catch{
					console.log("err")
				}
			}

		}
	}
</script>
